<template>
  <v-tooltip v-if="!hideSilentChannels || (hideSilentChannels && !shouldHide)" bottom>
    <template v-slot:activator="{ on, attrs }">
      <meter
        ref="meter"
        v-bind="attrs"
        v-on="on"
        :style="cssVars"
        :min="-48"
        :low="-12"
        :high="-3"
        :max="0"
        :value="db"
      >
        {{ db }}db
      </meter>
    </template>
    <span style="line-height: 1.5em">
      <strong>Channel</strong>: {{ channel }}
      <span v-if="db !== undefined && db_5s !== undefined && !shouldHide">
        <br />&nbsp;&nbsp;<strong>200ms</strong>: {{ db.toFixed(2) }}db
        <br />&nbsp;&nbsp;<strong>5s</strong>: {{ db_5s.toFixed(2) }}db
      </span>
    </span>
  </v-tooltip>
  
</template>

<script>
  
  export default {
    name: 'AudioLevelMeter',
    props: ['channel', 'db', 'db_5s', 'hideSilentChannels', 'transparent'],
    data() {
      return {
        min: -48,
        low: -12,
        high: -3,
        max: 0,
        
        lowRangeColor: '#62c462',
        midRangeColor: '#f9e406',
        highRangeColor: '#ee5f5b',
        backgroundColor: '#000000',
        
        width: 200,
      }
    },
    
    created() {
      window.addEventListener('resize', this.onResize)
    },
    
    destroyed() {
      window.removeEventListener('resize', this.onResize)
    },
    
    mounted() {
      setTimeout(() => {
        this.onResize()
      }, 100)
      
    },
    
    computed: {
      shouldHide() {
        return !(this.db != -48 && this.db != -100)
      },
      range() {
        return this.max - this.min
      },
      widthMax() {
        return this.width + 'px'
      },
      widthHigh() {
        return this.width * (1 - (1 / this.range) * (this.max - this.high)) + 'px'
      },
      widthLow() {
        return this.width * (1 - (1 / this.range) * (this.max - this.low)) + 'px'
      },
      widthMinimum() {
        return '0px'
      },
      cssVars() {
        return {
          '--background-color': this.backgroundColor,
          '--low-range-color': this.lowRangeColor,
          '--mid-range-color': this.midRangeColor,
          '--high-range-color': this.highRangeColor,
          
          '--width-minimum': this.widthMinimum,
          '--width-low': this.widthLow,
          '--width-high': this.widthHigh,
          '--width-max': this.widthMax,
          
          'opacity': (this.transparent) ? 0.7 : 1,
        }
      }
    },
    methods: {
      onResize() {
        if (this.$refs.meter) {
          this.width = this.$refs.meter.offsetWidth
        }
      }
    }
  }
</script>
<style lang="css" scoped>
meter {
  width: 100%;
  height: 8px;
  margin: 2px;
  
  background-color: var(--background-color);
  background: var(--background-color);

  border-radius: 2px;
  
  -webkit-appearance: none;
}

meter::-moz-meter-bar {
  background-image: linear-gradient(90deg,
    var(--low-range-color) var(--width-minimum),
    var(--low-range-color) var(--width-low),
    var(--mid-range-color) var(--width-low),
    var(--mid-range-color) var(--width-high),
    var(--high-range-color) var(--width-high),
    var(--high-range-color) var(--width-max));
}

meter::-webkit-meter-bar {
  height: 8px;
  border-radius: 2px;
}

meter::-webkit-meter-optimum-value,
meter::-webkit-meter-suboptimum-value,
meter::-webkit-meter-even-less-good-value {
  background-image: linear-gradient(90deg,
      var(--low-range-color) var(--width-minimum),
      var(--low-range-color) var(--width-low),
      var(--mid-range-color) var(--width-low),
      var(--mid-range-color) var(--width-high),
      var(--high-range-color) var(--width-high),
      var(--high-range-color) var(--width-max));
}
</style>